const de = {
  message: "Das hat leider nicht geklappt. Bitte versuche es erneut.",
}

const en: typeof de = {
  message: "Something went wrong. Please try again.",
}

export const errorText = { de, en }
